// extracted by mini-css-extract-plugin
module.exports = {"container":"PercentInput_container__qSybH","input":"PercentInput_input__2TIEY","percent":"PercentInput_percent__1UXFf"};